import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_UPDATE_ONSITE_SCHEDULE } from "../../action-types/actions";

export const updateOnsiteScheduleReducer = createAsyncThunk(
  ACTIONS_UPDATE_ONSITE_SCHEDULE.update_onsite_schedule,
  async ({ appointmentId, payload }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.updateOnsiteSchedule}/${appointmentId}/update-onsite-schedule`,
        payload,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success("Onsite schedule updated successfully");
        return response.data;
      } else {
        toast.error(
          response?.data?.message || "Failed to update onsite schedule",
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while updating onsite schedule";

      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
